module.exports = __webpack_public_path__ + "static/media/bn_brand_kit_closeup.c2b978af.png";